module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Christopher_Hauff.ce5d58ef.jpg";